import * as React from "react"
const Glow = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={24}
    height={24}
    viewBox="0 0 32 32"
    {...props}
  >
    <style>
      {
        ".st0{fill:#231f20}.st1{fill:#0b1719}.st2{fill:#a3aeb5}.st3{fill:#cc4121}.st4{fill:#dbd2c1}.st5{fill:#3d3935}.st6{fill:#8d3e93}.st7{fill:#bf63c1}.st8{fill:#e0a838}.st9{fill:#788287}.st10{fill:none}.st11{fill:#d1712a}.st12{fill:#af9480}"
      }
    </style>
    <g id="Uploaded to svgrepo.com">
      <path
        d="m4.85 28.5 5-9H7.854L16 5.02l8.146 14.48H22.15l5 9z"
        style={{
          fill: "#6f9b45",
        }}
      />
      <path
        d="M14.5 28.5h3v3h-3z"
        style={{
          fill: "#716558",
        }}
      />
      <path
        d="M11 26a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm8-5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-5-8a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm2-7.761-1.61.847.308-1.793-1.303-1.27 1.8-.262L16 1.129l.806 1.632 1.8.262-1.303 1.27.308 1.793L16 5.239z"
        style={{
          fill: "#ead13f",
        }}
      />
      <path
        d="M17 18a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm-1-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm0 16a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        style={{
          fill: "#c3cc6a",
        }}
      />
      <path
        d="M14 22a1 1 0 1 1-2 0 1 1 0 0 1 2 0zm4-9a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm4 12a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"
        style={{
          fill: "#fffaee",
        }}
      />
      <path
        d="M23 20h2L17.441 6.562l.833.438-.434-2.533 1.84-1.794-2.543-.37L16 0l-1.137 2.304-2.543.37 1.84 1.794L13.726 7l.833-.438L7 20h2l-5 9h10v3h4v-3h10l-5-9zM15.527 3.218 16 2.26l.473.959 1.058.154-.766.746.181 1.054L16 4.674l-.946.497.181-1.054-.766-.746 1.058-.153zM17 31h-2v-2h2v2zM5.7 28l5-9H8.71L16 6.04 23.29 19H21.3l5 9H5.7z"
        style={{
          fill: "#231f20",
        }}
      />
    </g>
  </svg>
)
export default Glow
